import { PageHeader } from "@/components/page-header";
import { useT } from "@/lib/i18n";

/**
 * Header strip for `/marketplace`. Pattern mirrors `SkillsPageHeader` so
 * the page chrome stays consistent across surfaces.
 */
export function MarketplacePageHeader() {
  const t = useT();
  return (
    <PageHeader
      eyebrow={t("common.eyebrow.workspace")}
      title={t("marketplace.title")}
      subtitle={t("marketplace.subtitle")}
    />
  );
}
